/**
 * ReadingGuideReadMore - Additional reading guide information
 * Migrated from front/src/components/ReadingGuideReadMore.js
 */
import React from 'react';
import MarkdownText from './MarkdownText';
import useReadingGuide from '../hooks/ui/useReadingGuide';

/**
 * ReadingGuideReadMore component - Extended information about indicators
 * @returns {JSX.Element} ReadingGuideReadMore component
 */
const ReadingGuideReadMore = () => {
  const { getText } = useReadingGuide();

  return <MarkdownText>{getText('lire-la-suite')}</MarkdownText>;
};

ReadingGuideReadMore.displayName = 'ReadingGuideReadMore';

export default React.memo(ReadingGuideReadMore);
